import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CompanyNgrxState as State, COMPANY_NGRX_FEATURE_KEY } from './company.reducer';

export const companyNgrxState = createFeatureSelector<State>(COMPANY_NGRX_FEATURE_KEY);

export const getAllCompanies = createSelector(companyNgrxState, (state: State) => state.all);
export const getSelectedCompany = createSelector(companyNgrxState, (state: State) => state.selected);
export const getPowerUsers = createSelector(companyNgrxState, (state: State) => state.powerUsers);
export const getLoadedStatus = createSelector(companyNgrxState, (state: State) => state.loaded);
